import React, { useMemo } from 'react';
import { CreateEditEventFlowStore, ToolMode } from '~admin/store/create-edit-event-flow-store';
import { useProvidedStore } from '~common/hook/use-provided-store';
import { StoreProvider, StoreProviderProps } from '~common/store/store-provider.component';

interface ProviderProps extends StoreProviderProps<CreateEditEventFlowStore> {
  mode: ToolMode;
}

const createEditEventFlowStoreContext = React.createContext<CreateEditEventFlowStore | null>(null);

export const CreateEditEventFlowStoreProvider: React.FunctionComponent<ProviderProps> = ({
  mode,
  ...rest
}) => {
  const store = useMemo(() => new CreateEditEventFlowStore(mode), [mode]);
  return <StoreProvider store={store} context={createEditEventFlowStoreContext} {...rest} />;
};

export const useCreateEditEventFlowStore = (): CreateEditEventFlowStore => {
  return useProvidedStore(createEditEventFlowStoreContext, 'CreateEditEventFlowStore');
};



// WEBPACK FOOTER //
// ./store/create-edit-event-flow-store-provider.tsx